const MeaPageHeader = ({ children }) => {
  return <div className="flex flex-wrap">{children}</div>;
};

export default MeaPageHeader;
